<template>
	<div class="content-box-wrapper margin-bottom-xs-2 module">
		<div class="content-box-header">
			<div class="row align-items-center">
				<div class="col-12 col-md">
					<a
						href="#"
						class="text-decoration-none"
						@click.prevent="goToDashboard"
						><Icon
							class="margin-right-xs-1 icon-17"
							:icon="'arrow-thin-left'"
						/>
						Tillbaka</a
					>
				</div>
				<div class="col">
					<h2
						class="content-box-header__headline text-17 text-md-center"
					>
						<span v-html="module.name"></span>: svar
					</h2>
				</div>
				<div class="d-none d-md-block col"></div>
			</div>
		</div>
		<div
			class="module-description content-box-padding padding-top-xs-2 padding-bottom-xs-2 padding-top-md-4 padding-bottom-md-4"
			:style="'background-image: url(' + module.image + ');'"
			:class="module.color_scheme"
			v-html="module.description"
		></div>
		<div class="content-box-padding">
			<ResourceStats
				v-for="resource in module.resources"
				:resource="resource"
				:key="resource.resource_id"
			/>
		</div>
	</div>
</template>
<script>
import ResourceStats from "./ResourceStats.vue";
import ModuleProgressBar from "./../partials/ModuleProgressBar.vue";
import Icon from "./../partials/Icon.vue";

export default {
	name: "Module",
	props: [],
	components: { ResourceStats, ModuleProgressBar, Icon },
	computed: {
		module() {
			return this.$store.state.activeModuleStats;
		}
	},
	methods: {
		goToDashboard() {
			this.$store.dispatch("goToDashboard");
		}
	},
	mounted() {}
};
</script>